import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as LayoutActions from '../../../core/actions/layout.actions';
import {ProductDictionary} from '../../../products/models/product';
import * as fromProducts from '../../../products/reducers';
import {
    getIsCreateNewQuoteMenuOpen,
    getIsQuoteListOpen,
    getIsQuoteViewSelectionOpen,
    getIsSubmittedQuoteListOpen
} from '../../../reducers';
import * as QuoteActions from '../../actions/quote.action';
import {CountryDictionary} from '../../model/country';
import {Quote} from '../../model/quote';
import {QuoteBarItem} from '../../model/quote-bar-item';
import {QuoteEditProductCommand, QuoteProductCommand} from '../../model/quote-commands';
import * as fromQuotes from '../../reducers';

@Component({
    selector: 'app-quotes-page',
    templateUrl: './quotes-page.component.html',
    styleUrls: ['./quotes-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class QuotesPageComponent implements OnInit {
    quotes$: Observable<QuoteBarItem[]>;
    submittedQuotes$: Observable<QuoteBarItem[]>;
    isPending$: Observable<boolean>;
    selectedQuoteBarItem$: Observable<QuoteBarItem>;
    selectedQuote$: Observable<Quote>;
    newlyCreatedQuoteBarItem$: Observable<QuoteBarItem>;
    newlyCreatedQuote$: Observable<Quote>;
    quoteListOpen$: Observable<boolean>;
    quoteViewSelectionOpen$: Observable<boolean>;
    submittedQuoteListOpen$: Observable<boolean>;
    productDictionary$: Observable<ProductDictionary>;
    productsIsLoading$: Observable<boolean>;
    countryDictionary$: Observable<CountryDictionary>;
    createNewQuoteOpen$: Observable<boolean>;

    constructor(private store: Store<fromQuotes.State>) {
    }

    onDeleteQuote(quote: Quote) {
        console.log('Delete the quote: ', quote);
        this.store.dispatch(QuoteActions.deleteQuote({command: {quote: quote}}));
    }

    onDeleteQuoteProduct(quoteProductCommand: QuoteProductCommand) {
        console.log('Delete the product from the quote: ', quoteProductCommand);
        this.store.dispatch(QuoteActions.deleteProduct({command: quoteProductCommand}));
    }

    onEditQuoteProduct(quoteEditProductCommand: QuoteEditProductCommand) {
        console.log('Edit the product from the quote: ', quoteEditProductCommand);
        this.store.dispatch(QuoteActions.editProduct({command: quoteEditProductCommand}));
    }

    onSelectQuote(quoteBarItem: QuoteBarItem) {
        console.log('Select the quote bar item: ', quoteBarItem);
        this.store.dispatch(QuoteActions.select({command: {quote: quoteBarItem.quote}}));
        this.store.dispatch(QuoteActions.changeChosenQuote({chosenQuote: quoteBarItem.quote}));
        this.store.dispatch(QuoteActions.openQuoteDetail());
    }

    onDeselectQuote() {
        this.store.dispatch(QuoteActions.select({command: {quote: null}}));
        this.store.dispatch(QuoteActions.changeChosenQuote({chosenQuote: null}));
        this.store.dispatch(QuoteActions.deselectNewlyCreatedQuote());
    }

    ngOnInit(): void {
        console.log('init');
        this.quotes$ = this.store.pipe(select(fromQuotes.getNewQuoteBarItems));
        this.submittedQuotes$ = this.store.pipe(select(fromQuotes.getSubmittedQuoteBarItems));
        this.isPending$ = this.store.pipe(select(fromQuotes.getIsPending));

        this.selectedQuoteBarItem$ = this.store.pipe(select(fromQuotes.getSelectedQuoteBarItem));
        this.selectedQuote$ = this.store.pipe(select(fromQuotes.getChosenQuote));

        this.newlyCreatedQuoteBarItem$ = this.store.pipe(select(fromQuotes.getNewlyCreatedQuoteBarItem));
        this.newlyCreatedQuote$ = this.store.pipe(select(fromQuotes.getNewlyCreatedQuote));

        this.productDictionary$ = this.store.pipe(select(fromProducts.getProductEntities));
        this.productsIsLoading$ = this.store.pipe(select(fromProducts.getProductsIsLoading));
        this.countryDictionary$ = this.store.pipe(select(fromQuotes.getCountryEntities));

        this.quoteListOpen$ = this.store.pipe(select(getIsQuoteListOpen));
        this.quoteViewSelectionOpen$ = this.store.pipe(select(getIsQuoteViewSelectionOpen));
        this.submittedQuoteListOpen$ = this.store.pipe(select(getIsSubmittedQuoteListOpen));
        this.createNewQuoteOpen$ = this.store.pipe(select(getIsCreateNewQuoteMenuOpen))
    }

    onCloseQuoteList() {
        this.store.dispatch(LayoutActions.closeQuoteList());
    }

    onCloseQuoteViewSelection() {
        this.store.dispatch(LayoutActions.closeQuoteViewSelection());
    }

    onOpenQuoteList() {
        this.store.dispatch(LayoutActions.openQuoteList());
    }

    onOpenCreateQuote() {
        this.store.dispatch(LayoutActions.openCreateNewQuoteMenu());
    }

    onOpenSubmittedQuotesList() {
        this.store.dispatch(LayoutActions.openSubmittedQuoteList());
    }
}
